import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCertificateByShareId } from "../api/certificate";
import DownloadCertificatePdf from "./downlaodCertificatePdf";

export default function () {
  const [certificate, setCertificate] = useState(null);

  const params = useParams();
  useEffect(() => {
    getCertificateByShareId(params.shareId).then((res) => {
      setCertificate(res);
    });
  }, []);

  return (
    <>
      <div>
        {certificate && (
          <DownloadCertificatePdf
            certificateProp={certificate}
            autoDownload={true}
          />
        )}
      </div>
    </>
  );
}
